import { SectionAlert, Txt } from '@vst/beam';
import { Router } from '@vst/beam-icons/icons';
import { useTranslation } from 'react-i18next';

export const SwitchAlert = () => {
  const { t } = useTranslation('Network');

  return (
    <SectionAlert
      type="info"
      icon={Router}
      size="large"
      contentSlot={
        <Txt variant="linkSmall" color="regular">
          <Txt variant="smallBold">{t('networkManagement.headsUp')}</Txt>
          {t('networkManagement.subTypeChangeNotice')}
        </Txt>
      }
    />
  );
};
